export const config = {
  routes: {
    favourites: {
      path: process.env.REACT_APP_FAV_PATH || '/favourites',
    },
    blog: {
      path: process.env.REACT_APP_BLOG_PATH || '/blogg',
      id: process.env.REACT_APP_BLOG_ID || 218,
      mainLevel: 1,
      menu: true,
    },
    brand: {
      id: 156,
    },
    category: {
      hide: false,
    },
    product: {
      hide: false,
    },
  },
  settings: {
    storeName: 'Stjarnurmakarna',
    siteContentId: {
      Default: 125,
      B2B: 131,
    },
    channels: {
      Default: {
        domain: 'stjarnurmakarna.se',
        name: 'stjarnurmakarna.se',
        // TODO: SET KLARNA ID
        klarna:
          'klarna_live_client_NDJVelBVeUUyc3F5KVB5LyovZUdvVVkoaGxoMDE1eiksZjI5ZWMyOGItZWI0Mi00NGU3LTljNDQtMzlkOTEzNWI2NzdjLDEsVGpBYUhVczlxV1JRZTZrNGJ1N28yNEkvNStDNlY3aUNpNVpnN3B5VkkrST0',
      },
    },
  },
  sizeGuide: {
    skipOnCategory: {
      smycken: true,
      tillbehor: true,
    },
  },
};

export const getChannel = (name) => {
  if (config.settings.channels[name]) return config.settings.channels[name];
  return config.settings.channels['Default'];
};
